// apps/hub/src/components/AuthLayout.tsx
// Layout minimal pour les routes /auth/* (hors HubLayout, plein écran).
// Fournit un fallback Suspense aux pages auth chargées en lazy.
import { LoadingSpinner } from '@neuroforge/ui'
import { Suspense } from 'react'
import { Outlet } from 'react-router'

export default function AuthLayout() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  )
}
